<script>
  import { tourFunctions } from "../tour-functions";

  /* ____________ Mobile Detection ____________ */
  import UA from "ua-parser-js";
  const ua = new UA();
  let isMobile = ua.getResult().device["type"] == "mobile";

  export let scene;
  export let text;
  export let x = 0;
  export let y = 0;
  export let width = 120;
  export let opacity = 1;

  function loadScene() {
    tourFunctions.loadScene(scene, 'overview_button');
    tourFunctions.focus();
  }

  let currentScene = tourFunctions.currentScene.getName();
  addEventListener("krpano:newpano", () => {
    currentScene = tourFunctions.currentScene.getName();
  });

  // set styles last
  let style = `
    top: ${y}px; 
    left: ${x}px; 
    opacity: ${opacity};
    width: ${width}px;
    `;

  // set background to solid if we are using layer opacity
  if (opacity !== 1) {
    style += `background: rgb(var(--scene-button-bg-color-rgb));`;
  }

  $: isButtonScene = currentScene === scene?.name || currentScene === scene;
</script>

{#if !isButtonScene}
  <button {style} on:click={loadScene} tabindex="0" class="scene-button">
    <svg
      class="back-arrow"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 37.9 26.8"
      style="enable-background:new 0 0 37.9 26.8;"
      xml:space="preserve"
    >
      <style type="text/css">
        .svg-back-arrow {
          fill: var(--scene-button-text-color);
        }
      </style>
      <path
        class="svg-back-arrow"
        d="M37.9,6v14.9h-20v-15L37.9,6z M17.9,0L0,13.4h17.9V0z M17.9,26.8L0,13.4h17.9V26.8z"
      />
    </svg>

    {text}
  </button>
{/if}

<style>
  button {
    appearance: none;
    margin: 0;
    cursor: pointer;

    position: absolute;
    z-index: 999;

    border: 3px solid transparent;
    border-radius: 3px;
    padding: 8px;

    font-size: 1.4rem;
    font-family: var(--font-heading), sans-serif;
    font-weight: 300;
    color: var(--scene-button-text-color);

    background: rgba(var(--scene-button-bg-color-rgb), 0.8);

    text-align: center;
    box-sizing: border-box;

    display: flex;
    align-items: center;
    justify-content: center;

    line-height: 1;
    border: 2px solid transparent;
  }

  .back-arrow {
    width: 0.75em;
    height: auto;
    margin-right: 5px;
  }

  button:hover {
    cursor: pointer;
    background: rgb(var(--scene-button-hover-bg-color-rgb));
    border: 2px solid var(--scene-button-text-color);
  }

  @media (max-width: 768px) {
    button {
      font-size: 1.1rem;
    }

    button:hover {
      border: none;
    }
  }
</style>
